export enum SuppliesPromotionKind {
  FreeProducts = "free_products",
}
